<div #container class="relative w-full">
  <div
    class="flex flex-wrap items-center justify-start gap-1.5"
    [style.max-height.px]="maxHeight()">
    @for (item of visibleEntries(); track item.id) {
      <div class="flex max-w-full min-w-0 items-center whitespace-nowrap">
        <ng-container
          [ngTemplateOutlet]="pillTemplate()"
          [ngTemplateOutletContext]="{
            $implicit: item,
            clickable: true,
            onClick: handlePillClick.bind(this)
          }" />
      </div>
    }
  </div>

  @if (hiddenCount() > 0) {
    <div
      #hiddenCountPill
      class="mt-1.5 flex max-w-full min-w-0 items-center whitespace-nowrap">
      <button
        type="button"
        class="hover:border-accent-border hover:bg-accent-interactive bg-elevated border-default inline-flex w-full max-w-48 cursor-pointer items-center justify-center overflow-hidden rounded-full border px-2.5 py-0.5 transition-all"
        [appDropdown]="dropdownTemplate"
        [dropdownTrigger]="['click']">
        <p class="text-text-primary text-2xs truncate font-medium">
          {{ 'table.cell.pills.more' | translate: { count: hiddenCount() } }}
        </p>
      </button>
    </div>

    <ng-template #dropdownTemplate>
      <div
        appContentSizedPanel
        class="pills-dropdown-list flex flex-col gap-2 overflow-auto p-2">
        @for (item of invisibleEntries(); track item.id) {
          <div class="flex items-center gap-1.5">
            <ng-container
              [ngTemplateOutlet]="pillTemplate()"
              [ngTemplateOutletContext]="{
                $implicit: item,
                clickable: true,
                onClick: handlePillClick.bind(this)
              }" />
          </div>
        }
      </div>
    </ng-template>

    <app-tooltip
      class="z-100"
      [target]="hiddenCountPill"
      [position]="'bottom'"
      [content]="'table.cell.pills.show_more' | translate: { count: hiddenCount() }" />
  }

  <div
    #measureContainer
    class="invisible absolute top-0 left-0 flex flex-wrap content-start items-center justify-start gap-1.5"
    [style.width.px]="containerWidth()"
    [style.max-height.px]="maxHeight()">
    @for (item of allEntries(); track item.id; let idx = $index) {
      <div
        #pill
        [attr.data-index]="idx"
        class="flex max-w-full min-w-0 items-center whitespace-nowrap">
        <ng-container
          [ngTemplateOutlet]="pillTemplate()"
          [ngTemplateOutletContext]="{
            $implicit: item,
            clickable: false,
            onClick: null
          }" />
      </div>
    }
  </div>
</div>
